import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCallrailRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#136CD4",
		d: "M8.2 7c4.2-4 11.2-3.8 15.6-.3q3.4 2.8 4 7.2v1.3q-.5.2-1.1.1H18q-.6.1-1-.5l-.1-.9v-2.7q.1-.4-.4-.7-.3-.2-.8-.2t-.7.4l-.1 1.4v9q0 .6.3 1.1l1.1.2q.7-.6.6-1.5v-2.4q0-.6.5-.8h1l.5-.1h7.8q.4 0 .7.3.3.1.2.6a11 11 0 0 1-4.9 7.3 13 13 0 0 1-9.6 1.4q-2-.6-3.7-1.7l-.7-.3-.2.3-1 1.3-.3.4c-1 .8-1 .8-1.6.8l-.2-.1c-.2-.6-.1-.8 0-1.4q.8-3.7-.6-7a12 12 0 0 1 3-12.2q.3 0 .4-.3m5.3 7.4c-.6 0-.6 0-1 .3l-.2 1.2v3.3l.1.8c.4.4.4.4.9.3q.4 0 .7-.6v-4.2q0-.7-.5-1.1m-3.2-2.6q-.4.1-.4.7v4.7q0 .8.3 1.3t.7.2q.3.1.6-.4v-6.1c-.5-.5-.5-.5-1.2-.4"
	})
});
export default SvgCallrailRegularIcon;
